// extracted by mini-css-extract-plugin
module.exports = {"popupStyle":"Popup_popupStyle__1eHLj","containerStyle":"Popup_containerStyle__1eEc8"};